<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">
      <div class="filter-wrapper">
        <div class="inputs-wrapper">
          <h3>Prodajno mjesto:</h3>
          <md-radio v-model="type" value="offline">Blagajna</md-radio>
          <md-radio v-model="type" value="online">Web</md-radio>
        </div>
        <div class="inputs-wrapper">
          <h3>Period:</h3>
          <div class="date-wrapper">
            <md-datepicker v-model="period.from" md-immediately>
            <label>Od</label>
            </md-datepicker>
            <md-datepicker v-model="period.to" md-immediately>
              <label>Do</label>
            </md-datepicker>
          </div>
        </div>
        <div class="inputs-wrapper with-button">
          <md-button class="md-raised md-dense md-primary" v-on:click="getByDate">
            Prikaži
          </md-button>
        </div>
      </div>
      <div ref="reports">
        <h2 class="md-title">
          Obračun pretplate
          <span>{{ title }}</span>
          <span class="lighter">Sezona 2025./2026.</span>
        </h2>
        <div v-if="Object.keys($store.state.receivedData.reportsGeneral.list.subscription).length != 0">
          <div class="reports-table print-table" v-for="report, reportKey, n in $store.state.receivedData.reportsGeneral.list.subscription">
            <h3 class="md-title">{{ getSubscriptionTitle(reportKey) }} {{ reportKey }}</h3>
            <md-table>
              <md-table-head>Kategorija</md-table-head>
              <md-table-head slot="md-table-row" md-selectable="single" md-auto-select v-for="pricelist, key in report.pricelist">
                {{ key }}
              </md-table-head>
              <md-table-head>Ukupno</md-table-head>
              <md-table-head slot="md-table-row" md-selectable="single" md-auto-select v-for="pricelist, key in report.pricelist">
                {{ key }}
              </md-table-head>
              <md-table-head>Ukupno</md-table-head>

              <md-table-row slot="md-table-row" md-selectable="single" md-auto-select v-for="category, key in report.category">

                <md-table-cell class="t-align-left">{{ key }}</md-table-cell>
                <md-table-cell v-for="pricelist, pricelistKey, i in report.pricelist">
                  {{ report['category-pricelist'][`${key}-${pricelistKey}`].count }}
                </md-table-cell>
                <md-table-cell>{{ category.count }}</md-table-cell>

                <md-table-cell v-for="pricelist, pricelistKey, i in report.pricelist">
                  {{ formatCurrency(report['category-pricelist'][`${key}-${pricelistKey}`].amount) }}
                </md-table-cell>
                <md-table-cell>{{ formatCurrency(category.amount) }}</md-table-cell>

              </md-table-row>

              <md-table-row slot="md-table-row" class="last-row" md-selectable="single" md-auto-select>
                <md-table-cell></md-table-cell>
                <md-table-cell v-for="pricelist, key in report.pricelist">
                  {{ pricelist.count }}
                </md-table-cell>
                <md-table-cell>{{ report.count }}</md-table-cell>
                <md-table-cell v-for="pricelist, key in report.pricelist">
                  {{ formatCurrency(pricelist.amount) }}
                </md-table-cell>
                <md-table-cell>{{ formatCurrency(report.amount) }}</md-table-cell>
              </md-table-row>
              <md-table-row slot="md-table-row" v-if="n == Object.keys($store.state.receivedData.reportsGeneral.list.subscription).length - 1" class="last-row bolded" md-selectable="single" md-auto-select>
                <md-table-cell>KUMULATIVNO:</md-table-cell>
                <md-table-cell v-for="pricelist, key in $store.state.receivedData.reportsGeneral.list.general.pricelist">
                  {{ pricelist.count }}
                </md-table-cell>
                <md-table-cell>{{ $store.state.receivedData.reportsGeneral.list.general.count }}</md-table-cell>
                <md-table-cell v-for="pricelist, key in $store.state.receivedData.reportsGeneral.list.general.pricelist">
                  {{ formatCurrency(pricelist.amount) }}
                </md-table-cell>
                <md-table-cell>{{ formatCurrency($store.state.receivedData.reportsGeneral.list.general.amount) }}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>
          <md-button class="md-primary md-dense md-raised print-btn fixed-print-btn" v-on:click="print($refs.reports)">
            Ispiši
          </md-button>
        </div>
        <div v-else class="error">
          <h3>Nažalost nema izvješća za prikaz</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsMixin from '../../../mixins/reports-mixin';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ReportsGeneral',
  mixins: [FormatCurrency, ReportsMixin('getReportsGeneral')],
}
</script>

<style lang="scss" scoped>

  .bolded{
    font-weight: bold;
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .reports-table{
    margin-top: 75px;
    &:last-of-type{
      margin-bottom: 50px;
    }
    h3{
      margin-left: 20px;
    }

		.md-table-cell, .md-table-head{
			&:not(:first-of-type){
				text-align: right;
			}
		}

		.subscription-type{
			color: #000;
			font-weight: bold;
			border-top: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Subscriptions/ReportsGeneral.vue